import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../../../services/modal.service';
import { VirtualCashModelsDto } from '../../models/virtual-cash.models';

@Component({
  selector: 'app-toggle-block-virtrual-cash-dialog',
  templateUrl: './toggle-block-virtrual-cash-dialog.component.html',
  styleUrls: ['./toggle-block-virtrual-cash-dialog.component.scss'],
})
export class ToggleBlockVirtualCashDialogComponent {
  @Input() selectedVirtualPos: VirtualCashModelsDto | null = null;

  @Output() blockEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() unlockEvent: EventEmitter<number> = new EventEmitter<number>();

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.isModalOpen$.next(false);
  }

  toggleBlock() {
    this.selectedVirtualPos?.is_blocked
      ? this.unlockEvent.emit(this.selectedVirtualPos?.id)
      : this.blockEvent.emit(this.selectedVirtualPos?.id);

    this.modalService.closeModal();
  }
}
